/*!
 * Copyright (c) Microsoft. All rights reserved.
 * Licensed under the MIT license. See LICENSE file in the project.
 */

/**
 * The vertical display ordering for workflow steps.
 */
export enum DisplayOrder {
	/**
	 * Render the first step on the top of the view
	 */
	FirstOnTop = 'first-on-top',

	/**
	 * Render the last step on top of the view
	 */
	LastOnTop = 'last-on-top',
}
